'use client';

import { cn } from '@/lib/utils';
import { Link as NavigationLink } from '@/i18n/navigation';

const Link = ({
    title,
    href,
    className,
    ariaLabel,
    target,
    children,
    onClick = () => {},
}: {
    href: string;
    title?: string;
    className?: string;
    ariaLabel?: string;
    target?: string;
    children?: React.ReactElement;
    onClick?: () => void;
}) => {
    const linkStyles = cn(
        'text-h5 font-normal hover:text-blue-200 transition-all ease-in-out duration-300 ease text-black group',
        className,
    );

    return (
        <NavigationLink
            className={linkStyles}
            href={href}
            target={target}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            {children ? (
                children
            ) : (
                <span className="bg-left-bottom bg-gradient-to-r from-blue-200 to-blue-200 bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                    {title}
                </span>
            )}
        </NavigationLink>
    );
};

export default Link;
